<template>
	<b-row>

		<ClientTable></ClientTable>
<!--		<ClientForPos></ClientForPos>-->

	</b-row>

</template>

<script>
import {mapGetters} from 'vuex'
import CreateClientModal from "./CreateClientModal";
import ChooseClient from "./ChooseClient";
import ClientTable from "./ClientTable";
import ClientForPos from "./ClientForPos";

const itemInitial = {
		id: null,
		conflicted: false,
		memberCard: '',
		memberCardDiscount: '',
		referalId: '',
		referalName: '',
		categoryId: '',
		categoryName: '',
		customerGroupId: '',
		customerGroupName: '',
		tags: '',
		firstName: '',
		lastName: '',
		middleName: null,
		dateOfBirth: '',
		gender: '',
		phone: '',
		mobile: '',
		email: '',
		address: null,
		address2: '',
		citizenId: null,
		citizenName: '',
		marriageStatusId: '',
		marriageStatusName: '',
		hireDate: null,
		dropdowns: {
			group: {
				items: [],
				value: null,
			},

		}


	};

	export default {
		name: "Sale",
		uploadModal: false,
		props: {
			caption: {
				type: String,
				default: 'Employees'
			},
			hover: {
				type: Boolean,
				default: true
			},
			striped: {
				type: Boolean,
				default: true
			},
			bordered: {
				type: Boolean,
				default: false
			},
			small: {
				type: Boolean,
				default: false
			},
			fixed: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				pushable: true,
				currentPage: 1,
				perPage: 20,
				item: null,
				createModal: false,
				mode: 'create',
				closable: false,
				loading: false,
				unitName: '',
				convert: true,
				errorMessage: null,
				newItem: {
					id: null,
					itemId: null,
					itemName: null,
					count: null,


				},
				childModal: false,
			}

		},
		methods: {

			openCreate() {

				setTimeout(() => {
					this.createModal = true
				}, 100);
			},
			close() {
				this.createModal = false;
				this.mode = 'create';
				this.item = null;

			},

		},


		computed: {
			...mapGetters('clients', [
				'total', 'clients',
			]),
			computedFields() {
				return [
					{
						key: 'id',
						label: this.$t('users-l.Id'),
						'class': 'role_id',
						sortable: true
					},
					{
						key: 'username',
						label: this.$t('users-l.username')
					},
					{
						key: 'actions',
						label: this.$t('actions.title'),
						'class': 'table_actions'

					},

				]
			}

		},
		components: {
			CreateClientModal,
			ChooseClient,
			ClientTable,
			ClientForPos


		}
	}
</script>

<style scoped>
</style>
